import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor() {
    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).subscribe(this.online$);
  }

  /**
   * Returns current connection status synchronously.
   */
  get isOnline(): boolean {
    return this.online$.value;
  }

  /**
   * Exposes connection status as an Observable.
   */
  monitorConnection(): Observable<boolean> {
    return this.online$.asObservable();
  }
}
